// Initial State

const state = {
  isAuthenticated: true
};

export default state;



// WEBPACK FOOTER //
// ./src/store/auth/state.js